const styles = (theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: { xs: "10px", sm: "20px" },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    width: "1100px",
    maxWidth: "95vw",
    maxHeight: "90vh",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "24px",
    boxShadow: theme.palette.mode === "dark"
      ? "0px 24px 48px rgba(0, 0, 0, 0.6)"
      : "0px 24px 48px rgba(0, 0, 0, 0.12)",
    overflow: "hidden",
    border: `1px solid ${theme.palette.divider}`,
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px 24px",
    borderBottom: `1px solid ${theme.palette.divider}`,
    background: theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, 0.02)"
      : "rgba(0, 0, 0, 0.015)",
    gap: "16px",
    flexWrap: "wrap",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  iconBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "48px",
    height: "48px",
    borderRadius: "14px",
    flexShrink: 0,
  },
  titleContainer: {
    display: "flex",
    flexDirection: "column",
  },
  titleText: {
    fontSize: "1.25rem",
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  subtitleText: {
    fontSize: "0.875rem",
    color: theme.palette.text.secondary,
  },
  headerRight: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
  },
  presetGroup: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    backgroundColor: theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, 0.05)"
      : "rgba(0, 0, 0, 0.04)",
    padding: "4px",
    borderRadius: "12px",
  },
  presetButton: {
    textTransform: "none",
    fontSize: "0.8rem",
    fontWeight: 600,
    borderRadius: "8px",
    padding: "4px 12px",
    minWidth: "auto",
  },
  closeButton: {
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, 0.05)"
      : "rgba(0, 0, 0, 0.04)",
    "&:hover": {
      backgroundColor: theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.15)"
        : "rgba(0, 0, 0, 0.1)",
    },
  },
  customRangeBox: {
    padding: "16px 24px",
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, 0.01)"
      : "rgba(0, 0, 0, 0.01)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    flexWrap: "wrap",
  },
  datePickerContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
  },
  content: {
    padding: "24px",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    flex: 1,
  },
  kpiContainer: {
    display: "grid",
    gridTemplateColumns: {
      xs: "repeat(2, 1fr)",
      sm: "repeat(3, 1fr)",
      md: "repeat(5, 1fr)",
    },
    gap: "16px",
  },
  kpiCard: {
    display: "flex",
    flexDirection: "column",
    padding: "16px",
    borderRadius: "16px",
    backgroundColor: theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, 0.03)"
      : "rgba(0, 0, 0, 0.02)",
    border: `1px solid ${theme.palette.divider}`,
    position: "relative",
    overflow: "hidden",
  },
  kpiLabel: {
    fontSize: "0.75rem",
    fontWeight: 600,
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
    marginBottom: "4px",
  },
  kpiValue: {
    fontSize: "1.25rem",
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  chartPaper: {
    padding: "20px",
    borderRadius: "18px",
    backgroundColor: theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, 0.02)"
      : "rgba(0, 0, 0, 0.01)",
    border: `1px solid ${theme.palette.divider}`,
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  chartHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  chartTitleBox: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  zoomActiveBox: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    backgroundColor: theme.palette.mode === "dark"
      ? "rgba(255, 152, 0, 0.15)"
      : "rgba(255, 152, 0, 0.1)",
    border: `1px solid ${theme.palette.warning.main}`,
    padding: "4px 12px",
    borderRadius: "12px",
  },
  chartContainer: {
    width: "100%",
    height: "420px",
    position: "relative",
  },
  loadingContainer: {
    width: "100%",
    height: "420px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
  },
});

export default styles;
